export const buildStatusClassNames = (status) => {
    switch (status?.toLowerCase()) {
        case "ordered":
            return "border-dark-pink bg-light-pink text-dark-pink";
        case "processing":
            return "border-dark-blue bg-blue text-white";
        case "cancelled":
            return "border-dark-orange bg-light-orange text-dark-orange";
        case "delivered":
        case "fulfilled":
            return "border-dark-green bg-light-green text-dark-green";
        default:
            return "border-dark-gray bg-light-gray text-dark-gray";
    }
};
export const lookupStatusText = (status) => {
    switch (status?.toLowerCase()) {
        case "ordered":
            return "Order Placed";
        case "processing":
            return "Order Processing";
        case "cancelled":
            return "Order Cancelled";
        case "delivered":
        case "fulfilled":
            return "Order Delivered";
        default:
            return "Unknown";
    }
};
export const lookupStatusLabel = (status) => {
    switch (status?.toLowerCase()) {
        case "ordered":
            return "Ordered";
        case "processing":
            return "Processing";
        case "cancelled":
            return "Cancelled";
        case "delivered":
        case "fulfilled":
            return "Delivered";
        default:
            return "Unknown";
    }
};
